/***
 *
 *   METRIC BADGE
 *   Color-coded numeric badge. Green above `high` threshold, yellow above `mid`, red below.
 *   Used for prompt counts, IP counts, and similar numeric health indicators.
 *
 *   PROPS
 *   value:      number
 *   thresholds: { high: number, mid: number }  (optional — defaults to { high: 50, mid: 10 })
 *
 ***/

import Style from './metric-badge.tailwind.js';
import { DEFAULT_THRESHOLDS } from './metric-badge.constants.js';

export function MetricBadge({ value, thresholds }) {
  const { high, mid } = { ...DEFAULT_THRESHOLDS, ...(thresholds || {}) };
  const color =
    value >= high ? Style.green
    : value >= mid ? Style.yellow
    : Style.red;

  return (
    <span className={`${Style.base} ${color}`}>
      {value}
    </span>
  );
}
